import { render } from "./WeightLossContentPtBR.vue?vue&type=template&id=0af98109&scoped=true"
import script from "./WeightLossContentPtBR.vue?vue&type=script&lang=js"
export * from "./WeightLossContentPtBR.vue?vue&type=script&lang=js"

import "./WeightLossContentPtBR.vue?vue&type=style&index=0&id=0af98109&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af98109"]])

export default __exports__